const getMaxValue = (value, maxLength) => {
	if (maxLength) {
		let maxValue = Math.pow(10, maxLength) - 1;
		if (value > 0) {
			value = value > maxValue ? maxValue : value;
		} else {
			maxValue *= -1;
			value = value < maxValue ? maxValue : value;
		}
	}
	return value;
};

const convertBasicInputToFloat = (inputValue, specialRule = null, maxLength, preventNumberConversion) => {
	let res = null;
	if (inputValue !== undefined) {
		if (typeof inputValue === 'number') {
			res = inputValue;
		} else if (typeof inputValue === 'string') {
			// Remove the trailing dashes
			inputValue = inputValue.replace(/-+$/, '');
			// Remove the asterisk
			inputValue = inputValue.replace('*', '');
			// Trim input for spaces
			inputValue = inputValue.replace(/ /g, '');
			// Replace comma with dot
			inputValue = inputValue.replace(',', '.');
			// Remove multiple dots
			inputValue = inputValue.replace('..', '.');

			// If it's only a number
			if (!isNaN(Number(inputValue)) && inputValue.length > 0) {
				if (preventNumberConversion) {
					res = inputValue;
				} else {
					res = Number(inputValue);
				}
			} else {
				// First replace accounts for currency symbols with dots (for example "kr.")
				if (preventNumberConversion) {
					res = String(inputValue)
						.replace(/([a-zA-Z]+[.])/g, '')
						.replace(/[^0-9.-]+/g, '');
				} else {
					res = Number(
						String(inputValue)
							.replace(/([a-zA-Z]+[.])/g, '')
							.replace(/[^0-9.-]+/g, '')
					);
				}
			}
		}
	}

	if (isNaN(res)) {
		res = 0;
	}

	res = getMaxValue(res, maxLength);

	return specialRule ? specialRule(res) : res;
};

export const convertBasicValue = (value, specialRule, showAsterisk, preventNumberConversion) => {
	if (typeof value === 'string') {
		value = value.trim();
	}
	const floatVal = convertBasicInputToFloat(value, specialRule, undefined, preventNumberConversion);

	const res = {
		float: null,
		full: null,
		error: false,
	};
	if (!isNaN(floatVal)) {
		res.float = floatVal;
		res.full = floatVal + (showAsterisk ? ' *' : '');
	} else if (floatVal === null || floatVal === undefined || floatVal === '') {
		res.float = null;
		res.full = '';
	} else {
		res.float = floatVal;
		res.full = floatVal;
		res.error = true;
	}

	return res;
};

export const convertIntoAffixedValue = (value, specialRule, affix) => {
	if (typeof value === 'string') {
		value = value.trim();
	}

	const val = convertBasicInputToFloat(value, specialRule);

	const res = {
		float: null,
		full: null,
		error: false,
	};

	if (typeof val === 'number') {
		res.float = val;
		res.full = val + `${affix}`;
	} else if (val === null || val === undefined || val === '') {
		res.float = null;
		res.full = '';
	} else {
		res.float = val;
		res.full = val;
		res.error = true;
	}

	return res;
};

export const convertIntoPerccentageValue = (
	value,
	specialRule,
	showAsterisk,
	additionalPercentageSignInfo,
	zeroToHundred,
	maxLength
) => {
	if (typeof value === 'string') {
		value = value.trim();
	}

	const percent = convertBasicInputToFloat(value, specialRule, maxLength);

	const res = {
		float: null,
		full: null,
		error: false,
	};

	if (typeof percent === 'number') {
		const roundedPercent = specialRule ? specialRule(percent) : Math.round(percent);
		res.float = roundedPercent / 100;
		res.full =
			roundedPercent + ' %' + (showAsterisk ? ' *' : additionalPercentageSignInfo ? additionalPercentageSignInfo : '');
		if (zeroToHundred && (percent < 0 || percent > 100)) {
			res.error = true;
		}
	} else if (percent === null || percent === undefined || percent === '') {
		res.float = null;
		res.full = '';
	} else {
		res.float = percent;
		res.full = percent;
		res.error = true;
	}

	return res;
};

const currencySymbolInFront = symbol => {
	return symbol === '$' || symbol === '€' || symbol === '฿' || symbol === '£';
};

export const convertIntoCurencyValue = (value, currency, specialRule, showAsterisk, intl, maxLength, symbolInFront) => {
	if (typeof value === 'string') {
		value = value.trim();
	}
	const showCurrencyOnLeft = typeof symbolInFront === 'boolean' ? symbolInFront : currencySymbolInFront(currency);
	const money = convertBasicInputToFloat(value, specialRule, maxLength);

	const res = {
		float: null,
		full: null,
		error: false,
	};

	if (typeof money === 'number') {
		res.float = money;
		res.full = showCurrencyOnLeft ? currency + ' ' + money : money + ' ' + currency;
		res.full += showAsterisk ? ' *' : '';
	} else if (money === null || money === undefined || money === '') {
		res.float = null;
		res.full = '';
	} else {
		res.float = money;
		res.full = money;
		res.error = true;
	}

	return res;
};

export const convertIntoHexValue = hex => {
	const res = {
		float: null,
		full: null,
		error: false,
	};

	let formatedHex = hex && hex.replace('#', '').toUpperCase();
	if (formatedHex.length === 3) {
		formatedHex = '' + formatedHex[0] + formatedHex[0] + formatedHex[1] + formatedHex[1] + formatedHex[2] + formatedHex[2];
	}

	if (formatedHex.length === 6 && !isNaN(Number('0x' + formatedHex))) {
		res.float = '#' + formatedHex;
		res.full = '#' + formatedHex;
	} else if (formatedHex === null || formatedHex === undefined || formatedHex === '') {
		res.float = null;
		res.full = '';
	} else {
		res.float = hex;
		res.full = hex;
		res.error = true;
	}

	return res;
};
